import "./LoadingProgress.css";

const LoadingProgress = ({ progress }) => {
  return (
    <div className="progress-wrapper">
      <div className="progress-bg">
        <div
          className="progress-bar"
          style={{ width: `${progress}%` }}
        >
          <div className="progress-marquee" />
        </div>
      </div>
    </div>
  );
};

export default LoadingProgress;
